// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xZqd","question":"styles_question__BC4Ed","description":"styles_description__3us03"};